module.exports = regex => regex instanceof RegExp ? regex.source : regex
